import { Button } from '@/components/common/Button';
import { Section } from '@/components/common/Section';
import {
  Card,
  CardContent,
  CardHeader,
  CardsContainer,
} from '@/components/dashboard/DashboardCard';
import { routes } from '@/routes/routes';
import { CheckmarkFilled } from '@carbon/icons-react';
import { Link } from '@tanstack/react-router';

export const MyCartCheckoutSuccessPage = () => {
  return (
    <Section>
      <CardsContainer className="-mx-4 lg:mx-0">
        <Card>
          <CardHeader>
            <div className="mx-auto flex flex-col items-center gap-6 py-8">
              <div className="bg-primary/10 flex size-20 items-center justify-center rounded-full">
                <CheckmarkFilled className="text-primary size-12" />
              </div>
              <h2 className="text-2xl font-semibold">Payment Successful!</h2>
              <p className="text-muted-foreground text-center">
                Thank you for your order! Your payment has been processed
                successfully.
              </p>
            </div>
          </CardHeader>

          <CardContent className="flex flex-col gap-3 pb-8 sm:flex-row sm:justify-center">
            <Button asChild variant="primary">
              <Link to={routes.dashboard.index}>Back to Dashboard</Link>
            </Button>
            <Button asChild variant="outlinePrimary">
              <Link to={routes.dashboard.myCarts.index}>View My Orders</Link>
            </Button>
          </CardContent>
        </Card>
      </CardsContainer>
    </Section>
  );
};
